import { render } from "./marketplace_success.html?vue&type=template&id=2464f69e&scoped=true&external"
import script from "./marketplace_success.js?vue&type=script&lang=js&external"
export * from "./marketplace_success.js?vue&type=script&lang=js&external"

import "./MicrosoftMarketplaceSuccess.vue?vue&type=style&index=0&id=2464f69e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2464f69e"]])

export default __exports__